import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../../components/forms/blackfillButton'
import '../../css/public/dashboard.css'
import { useState,useEffect } from 'react'
import ApiUrl from '../../configTools/apiUrl'

const Dashboard = () => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [Orders,setOrders] = useState([]);
    const [products,setProducts] = useState([]);
    useEffect(() => {
      fetch(ApiUrl.API_URL_ListingUser+"/"+User.username)
      .then(res=>res.json())
      .then(data =>{
          if(data.success)
          setProducts(data.responce);
      });
      fetch(ApiUrl.API_URL_Orders,{
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer '+User.token
          }
      })
      .then(res=>res.json())
      .then(data =>{
          if(data.success){
            setOrders(data.responce);
          }
      });
    },[User])
  return (
    <div className='public_dashboard_wrapper'>
      <div className='public_dashboard_container'>
        <div className='public_dashboard_row'>
            <div className='public_dashboard_sales_analysis'>
                <div className='public_dashboard_sales_analysis_container'>
                    <h5>Sales</h5>
                    <p>No sales yet.</p>
                </div>
            </div>
            <div className='public_dashboard_counter'>
                <div className='public_dashboard_counter_container'>
                    <h5>Orders</h5>
                    <h4>{Orders.length}</h4>
                    <Link to={'/dashboard/orders'}>
                        <Button Value={'View'}/>
                    </Link>
                </div>
                <div className='public_dashboard_counter_container'>
                    <h5>Listings</h5>
                    <h4>{products.length}</h4>
                    <Link to={'/dashboard/listings'}>
                        <Button Value={'View'}/>
                    </Link>
                </div>
            </div>
        </div>
        <div className='public_dashboard_row'>
            <div className='public_dashboard_row_w33'>
                <div className='public_dashboard_listings'>
                    <h5>Top Listings</h5>
                    {
                        products.slice(0,5).map((product,index)=>{
                            return(
                                <Link to={"/product/"+product.slug} key={index}>
                                    <div className='public_dashboard_listings_item'>
                                        <img src={ApiUrl.API_URL_Image_Thumbnail+product.image}/>
                                        <h3>{product.title}</h3>
                                        <h6>{product.price}</h6>
                                    </div>
                                </Link>
                            )
                        })
                    }
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
